import block from 'bem-css-modules';

block.setSettings({
  elementDelimiter: '_',
  modifierDelimiter: '__'
});

export default block;
